<template>
  <AGTag class="ag-tag-status-analise" readonly :class="computedClass" :label="computedLabel" />
</template>

<script>
import AGTag from '@/components/common/AGTag.vue';
import STATUS_ANALISE from '@/constants/ConstantStatusAnalise';

export default {
  components: {
    AGTag,
  },

  props: {
    status: {
      type: String || Object,
      validatior: (val) => Object.values(STATUS_ANALISE).includes(val),
    },
  },

  computed: {
    computedLabel() {
      if (!this.status) return 'Analisar';
      switch (this.status) {
        case STATUS_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
          return 'Esclarecimento';
        case STATUS_ANALISE.EM_ANALISE:
          return 'Em análise';
        case STATUS_ANALISE.ANALISADO:
          return 'Analisado';
        default:
          console.error(`Status de análise "${this.status}" não está mapeado`);
          return this.status;
      }
    },

    computedClass() {
      const computedClass = [];
      if (!this.status) {
        computedClass.push('--status-analisar');
        return computedClass.join(' ');
      }
      switch (this.status) {
        case STATUS_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
          computedClass.push('--status-pendente-de-esclarecimento');
          break;
        case STATUS_ANALISE.EM_ANALISE:
          computedClass.push('--status-em-analise');
          break;
        case STATUS_ANALISE.ANALISADO:
          computedClass.push('--status-analisado');
          break;
        default:
          console.error(`Status de análise "${this.status}" não está mapeado`);
          break;
      }

      return computedClass.join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin tagTypeStyles($backgroundColor, $textColor, $borderColor) {
  background-color: $backgroundColor !important;
  color: $textColor;
  border-color: $borderColor;
}

.ag-tag-status-analise {
  border: none;

  &.--status-pendente-de-esclarecimento {
    @include tagTypeStyles(#fae1fa, #610051, #fae1fa);
  }

  &.--status-em-analise {
    @include tagTypeStyles(#8e8e9347, #8e8e93, #8e8e9347);
  }

  &.--status-analisado {
    @include tagTypeStyles($brand-color-primary-light, $brand-color-primary-dark, $brand-color-primary-light);
  }
}
</style>
